import { type FC } from "react";
import { Stack } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { FilterProvider } from "@/partner/shared/components/Filter";
import { SupportRequestsFilter } from "./SupportRequestsFilter";
import { SupportRequestsList } from "./SupportRequestsList";
import { SupportRequestDialog } from "./SupportRequestDialog";

// Карточка по ?tab=edit&id= (PARTNER-PAGES); старые письма ведут на ?id=,
// поэтому диалог открывается по id при любом tab (R13).
export const SupportRequests: FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const id = searchParams.get("id");

  const handleOpen = (requestId: string) => {
    searchParams.set("tab", "edit");
    searchParams.set("id", requestId);
    setSearchParams(searchParams);
  };

  const handleClose = () => {
    searchParams.delete("tab");
    searchParams.delete("id");
    setSearchParams(searchParams);
  };

  return (
    <FilterProvider>
      <Stack spacing={1}>
        <SupportRequestsFilter />
        <SupportRequestsList onOpenRequest={handleOpen} />
      </Stack>

      <SupportRequestDialog
        open={Boolean(id)}
        requestId={id}
        onClose={handleClose}
      />
    </FilterProvider>
  );
};
